'use client';

import { MarkdownText } from '@/components/MarkdownText';
import { SideBarBox } from '../SideBarBox';

type Props = {
  title: string;
  markdown: string;
};

export const ObiContent: React.FC<Props> = ({ title, markdown }) => {
  return (
    <SideBarBox title={title}>
      <MarkdownText markdown={markdown} size="small" />
    </SideBarBox>
  );
};
